import {
    createSelector,
} from '@reduxjs/toolkit';

import {
    selectUserSelections,
    selectUserSelectionById,
} from './userSelectionsSelectors';

import {
    selectSelectionDetailsById,
    selectSelectionDetails,
} from './selectionDetailsSelectors';

import {
    isSelectionSuspended,
} from '~Betslip/utils/selectionChecks';

export const selectShowPriceChangeNotification = createSelector(
    [
        selectSelectionDetails,
        selectUserSelections,
    ],
    (selectionDetails, userSelections) => {
        return Object.values(userSelections).some(userSelection => {
            const selectionId = userSelection.id;
            const selection = selectionDetails[selectionId];
            if (!selection) {
                return false;
            }

            const hasPriceChanged = checkPriceChanged(userSelection, selection);

            return hasPriceChanged.priceChanged;
        });
    }
);

export const selectShowPriceChange = createSelector(
    [
        selectSelectionDetailsById,
        selectUserSelectionById,
    ],
    (selectionDetails, userSelection) => {
        if (!selectionDetails) {
            return false;
        }

        return checkPriceChanged(userSelection, selectionDetails);
    }
);

const checkPriceChanged = (userSelection, selection) => {
    const {
        sp_selected,
        original_price,
    } = userSelection;
    if (!selection) {
        return false;
    }
    const {
        decimal_price,
        sp_only,
    } = selection;

    const suspended = isSelectionSuspended(selection);

    const priceChanged = !suspended && !sp_selected && (Number(original_price) !== Number(decimal_price));
    let priceChangeDirection = null;
    const isSP = sp_only || sp_selected;

    if (priceChanged && !isSP) {
        if (Number(original_price) < Number(decimal_price)) {
            priceChangeDirection = 'lengthening';
        } else {
            priceChangeDirection = 'shortening';
        }
    }

    return {
        priceChanged,
        priceChangeDirection,
    };
};
